import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, toRef, watch } from 'vue'

import DocumentManager from '../../documents/manager/DocumentManager.vue'
import TransportationDateTimeRangePicker from '../TransportationDateTimeRangePicker.vue'
import TransportationLocationSelector from '../TransportationLocationSelector.vue'
import TransportationEmojiLabelField from '../TransportationEmojiLabelField.vue'
import FormGroup from '@/components/core/form/FormGroup.vue'
import LInput from '@/components/core/form/Input.vue'
import LTextarea from '@/components/core/form/Textarea.vue'
import { useSelectedTrip } from '@/composables/trip'
import { useTransportationStore } from '@/stores/transportation'
import { useRouteManagement } from '@/composables/route'
import { useTransportationDocuments } from '@/composables/transportation'
import { BoatTransportationUIInput } from '@/types/transportation'


export default /*#__PURE__*/_defineComponent({
  __name: 'BoatForm',
  props: {
    transportation: null,
    waypointId: null
  },
  setup(__props: any) {

const props = __props as {
  transportation: BoatTransportationUIInput
  waypointId: string
};



const trip = useSelectedTrip()
const transportationStore = useTransportationStore()
const transportation = toRef(props, 'transportation')

const idPrefix = computed(() => {
  return `transportation-${transportation.value._id ?? 'boat-new'}`
})

// Document Management ---------------------------------------------------------

const managedDocuments = useTransportationDocuments(transportation)

// Route Management ------------------------------------------------------------

const { calculateRoutes } = useRouteManagement(transportation)

watch(
  [() => transportation.value.origin, () => transportation.value.destination],
  async () => await calculateRoutes(),
)

onMounted(async () => {
  if (!transportation.value.route) {
    await calculateRoutes()
  }
})

// Show/Hide More Content ------------------------------------------------------

const hasContentInMoreSection = !!(
  managedDocuments.value.length > 0 ||
  transportation.value.provider ||
  transportation.value.bookingReference ||
  transportation.value.comment
)

const showContent = ref(hasContentInMoreSection)

function toggleMoreContent() {
  showContent.value = !showContent.value
}

return { __sfc: true,props, trip, transportationStore, transportation, idPrefix, managedDocuments, calculateRoutes, hasContentInMoreSection, showContent, toggleMoreContent, DocumentManager, TransportationDateTimeRangePicker, TransportationLocationSelector, TransportationEmojiLabelField, FormGroup, LInput, LTextarea }
}

})